import React, { useContext, memo, useCallback } from "react";
import styles from "./HourlyShiftsCell.module.scss";
import { ResourcePlannerContext } from "../../views/resourcePlanner/resourceMonitoring/ResourcePlannerContext";

const HourlyShiftsCell = memo(({ handleClick, item, index, identifier }) => {
  const { setDetail, setIsOpenPopover, detail } = useContext(ResourcePlannerContext);

  const handleShiftClick = useCallback((shift) => {
    setDetail({ 
      userIndex: index, 
      shift: { ...shift },
      hourlyIdentifier: identifier 
    });
    handleClick(true);
    setIsOpenPopover(null);
  }, [index, identifier, setDetail, handleClick, setIsOpenPopover]);

  return (
    <div className="d-flex align-items-center">
      {item.map((shift, ind) =>
        ind === 0 ? (
          <div
            key={`start-${ind}`}
            className={`${styles.shiftCell_wrapper} ${
              detail?.userIndex === index ? styles.selected : styles.unSelected
            } d-flex justify-content-end`}
            onClick={() => handleShiftClick(shift)}
          >
            <div
              className={`${styles.shiftCell} ${
                shift.colorType === 0
                  ? styles.FullyAvailable
                  : shift.colorType > 100
                  ? styles.OverBooked
                  : styles.OccupiedHours
              } ${styles.StartPoint}`}
              style={{ width: `${100 - shift.colorPercentage}%` }}
            >
              <div className={styles.shiftStatusBar}>
                <div className={styles.shiftCell_content}>
                  <div className="d-flex align-items-center text-nowrap">
                    <p className="text-sm-600 ms-1">
                      {shift.workingHours}/{shift.totalHours} hrs
                    </p>
                    <>
                      <span className="text-sm-400 me-1">• Tasks</span>
                      <div className={styles.tasksBadge}>
                        {shift.data?.[0]?.tasksCount || 0}
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : ind === item.length - 1 ? (
          <div
            key={`end-${ind}`}
            className={`${styles.shiftCell_wrapper} ${
              detail?.userIndex === index ? styles.selected : styles.unSelected
            } d-flex justify-content-start`}
            onClick={() => handleShiftClick(shift)}
          >
            <div
              className={`${styles.shiftCell} ${
                shift.colorType === 0
                  ? styles.FullyAvailable
                  : shift.colorType > 100
                  ? styles.OverBooked
                  : styles.OccupiedHours
              } ${styles.EndPoint}`}
              style={{ width: `${100 - shift.colorPercentage}%` }}
            >
              <div className={styles.shiftStatusBar}>{/* emptyCell */}</div>
            </div>
          </div>
        ) : (
          <div
            key={`mid-${ind}`}
            className={`${styles.shiftCell_wrapper} ${
              detail?.userIndex === index ? styles.selected : styles.unSelected
            }`}
            onClick={() => handleShiftClick(shift)}
          >
            <div
              className={`${styles.shiftCell} ${
                shift.colorType === 0
                  ? styles.FullyAvailable
                  : shift.colorType > 100
                  ? styles.OverBooked
                  : styles.OccupiedHours
              } ${styles.MidPoint}`}
            >
              <div className={styles.shiftStatusBar}>{/* emptyCell */}</div>
            </div>
          </div>
        )
      )}
    </div>
  );
});

HourlyShiftsCell.displayName = 'HourlyShiftsCell';

export default HourlyShiftsCell;
